import './App.css'
import { Redirect, Route, Switch } from 'react-router-dom'
import SignIn from './pages/SignIn'
import {
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import { useTranslation } from 'react-i18next'
import PrivateRoute from './routes/PrivateRoute'
import { useContext, useEffect, useRef, useState } from 'react'
import Home from 'pages/Home/Home'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from 'store/rootStore'
import { setAuthToken } from 'lib/utils'
import useRoutes from 'hooks/useRoutes'
import * as queryString from 'querystring'
import { HOME_URL, SIGNIN_URL } from 'constants/urls'
import axios from 'axios'
import ErrorModal from 'pages/Home/components/modals/ErrorModal'

const App = observer(({ location }) => {
  const { authStore } = useContext(RootStoreContext)
  const { t } = useTranslation()
  const _isMounted = useRef(true)
  const [appBar, SetAppBar] = useState(true)
  const [anchorEl, setAnchorEl] = useState(null)
  const [error, setError] = useState(false)
  const { goTo, setLastVisit, lastVisit } = useRoutes()
  const open = Boolean(anchorEl)
  const isAuthenticated = authStore.user.token

  axios.interceptors.response.use(
    response => response,
    err => {
      if (!err.message.includes('401')) {
        setError(err.message || 'An error occurred')
      }
      return Promise.reject(err)
    }
  )

  useEffect(() => {
    const values = queryString.parse(location.search)
    if (values && values.token) {
      authStore.setTokenFromQuery(values.token)
      SetAppBar(false)
    }
    if (authStore.user.token) {
      setAuthToken(authStore.user.token)
    } else {
      authStore.setAuthTokenFromLS() && goTo(lastVisit ? lastVisit : HOME_URL)
    }
    return () => {
      _isMounted.current = false
    }
  }, [])

  useEffect(() => {
    setLastVisit(location.pathname)
    const requestId = parseInt(location.pathname.replace('/home/', ''))
    if (!isNaN(requestId)) {
      localStorage.setItem('requestId', requestId)
    }
  }, [location.pathname, setLastVisit])

  const handleMenu = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    setAnchorEl(null)
    authStore.clearAuth()
  }

  const getRoute = () => {
    if (isAuthenticated) {
      if (lastVisit) {
        return lastVisit
      }
      return HOME_URL
    }
    return SIGNIN_URL
  }

  return (
    <>
      {appBar && (
        <AppBar
          position={'static'}
          style={{
            backgroundColor: '#333'
          }}
        >
          <Toolbar>
            <Typography variant={'h6'} style={{ flexGrow: '1' }}>
              Служба поддержки
            </Typography>
            {isAuthenticated && (
              <div>
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <MoreIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleLogout}> {t('signOut')}</MenuItem>
                </Menu>
              </div>
            )}
          </Toolbar>
        </AppBar>
      )}
      <Switch>
        <PrivateRoute auth={isAuthenticated} path={HOME_URL} component={Home} />
        <Route path={SIGNIN_URL} render={props => <SignIn {...props} />} />
        <Route path={'/'} render={() => <Redirect to={getRoute()} />} />
      </Switch>
      <ErrorModal e={error} close={() => setError(false)} snackbar={true} />
    </>
  )
})

export default App
